import { Pipe, PipeTransform } from '@angular/core';

const statuses: Record<string, string> = {
  day_rate: 'Per Day',
  per_load_percent: 'Per Load Percent',
  lease_to_own: 'Lease To Own',
};

@Pipe({
  name: 'contractStatus',
})
export class ContractStatusPipe implements PipeTransform {
  public transform(value: string): unknown {
    return statuses[value];
  }
}
